/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PageInfoDto } from '../models/page-info-dto';
import { termsAdminControllerActivateV1 } from '../fn/terms-admin/terms-admin-controller-activate-v-1';
import { TermsAdminControllerActivateV1$Params } from '../fn/terms-admin/terms-admin-controller-activate-v-1';
import { termsAdminControllerCreateV1 } from '../fn/terms-admin/terms-admin-controller-create-v-1';
import { TermsAdminControllerCreateV1$Params } from '../fn/terms-admin/terms-admin-controller-create-v-1';
import { termsAdminControllerDeleteV1 } from '../fn/terms-admin/terms-admin-controller-delete-v-1';
import { TermsAdminControllerDeleteV1$Params } from '../fn/terms-admin/terms-admin-controller-delete-v-1';
import { termsAdminControllerFindByIdV1 } from '../fn/terms-admin/terms-admin-controller-find-by-id-v-1';
import { TermsAdminControllerFindByIdV1$Params } from '../fn/terms-admin/terms-admin-controller-find-by-id-v-1';
import { termsAdminControllerFindByTypeV1 } from '../fn/terms-admin/terms-admin-controller-find-by-type-v-1';
import { TermsAdminControllerFindByTypeV1$Params } from '../fn/terms-admin/terms-admin-controller-find-by-type-v-1';
import { termsAdminControllerSearchV1 } from '../fn/terms-admin/terms-admin-controller-search-v-1';
import { TermsAdminControllerSearchV1$Params } from '../fn/terms-admin/terms-admin-controller-search-v-1';
import { termsAdminControllerUpdateV1 } from '../fn/terms-admin/terms-admin-controller-update-v-1';
import { TermsAdminControllerUpdateV1$Params } from '../fn/terms-admin/terms-admin-controller-update-v-1';
import { TermsDto } from '../models/terms-dto';

@Injectable({ providedIn: 'root' })
export class TermsAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `termsAdminControllerSearchV1()` */
  static readonly TermsAdminControllerSearchV1Path = '/api/v1/terms/admin';

  /**
   * 약관 목록 조회 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `termsAdminControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  termsAdminControllerSearchV1$Response(params: TermsAdminControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<TermsDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = termsAdminControllerSearchV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 약관 목록 조회 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `termsAdminControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  termsAdminControllerSearchV1(params: TermsAdminControllerSearchV1$Params, context?: HttpContext): Observable<{
'items': Array<TermsDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.termsAdminControllerSearchV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<TermsDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<TermsDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `termsAdminControllerCreateV1()` */
  static readonly TermsAdminControllerCreateV1Path = '/api/v1/terms/admin';

  /**
   * 약관 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `termsAdminControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  termsAdminControllerCreateV1$Response(params: TermsAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<TermsDto>> {
    const obs = termsAdminControllerCreateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 약관 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `termsAdminControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  termsAdminControllerCreateV1(params: TermsAdminControllerCreateV1$Params, context?: HttpContext): Observable<TermsDto> {
    const resp = this.termsAdminControllerCreateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TermsDto>): TermsDto => r.body)
    );
  }

  /** Path part for operation `termsAdminControllerFindByTypeV1()` */
  static readonly TermsAdminControllerFindByTypeV1Path = '/api/v1/terms/admin/type/{type}';

  /**
   * 특정 유형의 약관 이력 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `termsAdminControllerFindByTypeV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  termsAdminControllerFindByTypeV1$Response(params: TermsAdminControllerFindByTypeV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TermsDto>>> {
    const obs = termsAdminControllerFindByTypeV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 특정 유형의 약관 이력 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `termsAdminControllerFindByTypeV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  termsAdminControllerFindByTypeV1(params: TermsAdminControllerFindByTypeV1$Params, context?: HttpContext): Observable<Array<TermsDto>> {
    const resp = this.termsAdminControllerFindByTypeV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<TermsDto>>): Array<TermsDto> => r.body)
    );
  }

  /** Path part for operation `termsAdminControllerFindByIdV1()` */
  static readonly TermsAdminControllerFindByIdV1Path = '/api/v1/terms/admin/{id}';

  /**
   * 약관 상세 조회 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `termsAdminControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  termsAdminControllerFindByIdV1$Response(params: TermsAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<TermsDto>> {
    const obs = termsAdminControllerFindByIdV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 약관 상세 조회 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `termsAdminControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  termsAdminControllerFindByIdV1(params: TermsAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<TermsDto> {
    const resp = this.termsAdminControllerFindByIdV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TermsDto>): TermsDto => r.body)
    );
  }

  /** Path part for operation `termsAdminControllerDeleteV1()` */
  static readonly TermsAdminControllerDeleteV1Path = '/api/v1/terms/admin/{id}';

  /**
   * 약관 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `termsAdminControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  termsAdminControllerDeleteV1$Response(params: TermsAdminControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = termsAdminControllerDeleteV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 약관 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `termsAdminControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  termsAdminControllerDeleteV1(params: TermsAdminControllerDeleteV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.termsAdminControllerDeleteV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `termsAdminControllerUpdateV1()` */
  static readonly TermsAdminControllerUpdateV1Path = '/api/v1/terms/admin/{id}';

  /**
   * 약관 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `termsAdminControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  termsAdminControllerUpdateV1$Response(params: TermsAdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<TermsDto>> {
    const obs = termsAdminControllerUpdateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 약관 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `termsAdminControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  termsAdminControllerUpdateV1(params: TermsAdminControllerUpdateV1$Params, context?: HttpContext): Observable<TermsDto> {
    const resp = this.termsAdminControllerUpdateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TermsDto>): TermsDto => r.body)
    );
  }

  /** Path part for operation `termsAdminControllerActivateV1()` */
  static readonly TermsAdminControllerActivateV1Path = '/api/v1/terms/admin/{id}/activate';

  /**
   * 약관 활성화.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `termsAdminControllerActivateV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  termsAdminControllerActivateV1$Response(params: TermsAdminControllerActivateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<TermsDto>> {
    const obs = termsAdminControllerActivateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 약관 활성화.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `termsAdminControllerActivateV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  termsAdminControllerActivateV1(params: TermsAdminControllerActivateV1$Params, context?: HttpContext): Observable<TermsDto> {
    const resp = this.termsAdminControllerActivateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TermsDto>): TermsDto => r.body)
    );
  }

}
